import { fork, all } from 'redux-saga/effects';

import coreSaga from './core';
import dashboardSaga from './dashboard';
import detailsSaga from './details';
import releaseModalSaga from './release-modal';

export default function* releasesSaga() {
  yield all([
    fork(coreSaga),
    fork(dashboardSaga),
    fork(detailsSaga),
    fork(releaseModalSaga),
  ]);
}
